<div class="ratio" [ngClass]="aspectRatio()">
  @if (allowsTrackingCookies()) {
    <iframe [src]="videoUrl()" [title]="title()" allowfullscreen></iframe>
  } @else {
    <img
      [src]="imageUrl()"
      class="img-fluid image-cover mx-auto d-block"
      alt="Frame uit video die afgespeeld kan worden na het toestaan van tracking cookies."
    />
    <div
      class="p-2 fw-bold pos-a text-center justify-content-center align-items-center d-flex flex-column bg-white bg-opacity-75"
    >
      <p>
        Om video's te bekijken op deze website moet je het gebruik van cookies
        toestaan.
      </p>
      <crnt-button-alt variant="tertiary">
        <a
          [routerLink]="[]"
          [queryParams]="queryParams()"
          [queryParamsHandling]="'merge'"
          >Cookievoorkeuren wijzigen</a
        >
      </crnt-button-alt>
    </div>
  }
</div>
